import {useEffect, useRef} from "react";

/**
 * When a child component receives a ForwardedRef, it is often to expose the ref
 * to a parent. However, sometimes the child component may need to use the ref
 * itself. In this case, the child can use this hook to receive a ref regardless
 * of whether the parent forwarded a ref.
 *
 * https://stackoverflow.com/a/73046577/26853284
 */
export function useForwardedRef<T>(ref: React.ForwardedRef<T>) {
  const innerRef = useRef<T>(null);

  useEffect(() => {
    if (!ref) return;
    if (typeof ref === "function") {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  });

  return innerRef;
}
